const cs = {
  home: {
    biometric_label: "BIOMETRICKÉ OVĚŘENÍ IDENTITY",
    title: "Zpětné vyhledávání obličejů snadno",
    description:
      "Nahrajte vysokorozlišovací portrét pro porovnání s globálními digitálními archivy pomocí pokročilého neurálního porovnávání.",
    drag_drop: "Přetáhněte a pusťte svůj obrázek",
    file_formats: "Podporuje RAW, JPEG nebo PNG (Max 15MB)",
    select_file: "VYBRAT SOUBOR ZE SYSTÉMU",
    initiate_scan: "Zahájit Forenzní Sken",
    upload_hint: "PROSÍM NAHRAJTE OBRÁZEK PRO POKRAČOVÁNÍ",
    uploading: "Nahrávání",
    searching: "Skenování",
    result_title: "Výsledky",
    drop_here: "Pusťte obrázek sem...",
    billion_faces: "Porovnejte s více než 1 miliardou tváří na internetu",
    login_to_search: "Přihlásit se pro hledání",
    login_required: "Přihlaste se nebo vytvořte účet pro použití této aplikace",
    not_enough_tokens: "Nedostatek tokenů",
    please_wait: "Prosím počkejte pár minut",
    leave_confirmation: "Probíhá proces. Jste si jistý, že chcete odejít?",
  },
  sources: {
    section_title: "Zdroje, Které Prohledáváme",
    social_media: {
      name: "Sociální Sítě",
      description:
        "Křížové odkazy v hlavních sociálních sítích a veřejných profilech.",
    },
    web: {
      name: "Web",
      description: "Skenuje otevřený web pro veřejně dostupná data tváří.",
    },
    scammers: {
      name: "Podvodníci",
      description: "Porovnává s databázemi identity známých podvodníků.",
    },
    sexual_offenders: {
      name: "Sexuální Pachatelé",
      description:
        "Křížové odkazy s veřejnými registry registrovaných pachatelů.",
    },
    videos: {
      name: "Videa",
      description: "Extrahuje a porovnává tváře z veřejných video platforem.",
    },
    police_photos: {
      name: "Policejní Fotografie",
      description: "Porovnává s veřejně dostupnými policejními databázemi.",
    },
    news_and_blogs: {
      name: "Zprávy a Blogy",
      description: "Prohledává zpravodajské archivy, redakční obsah a blogy.",
    },
  },
  header: {
    scan: "SKENOVAT",
    history: "HISTORIE",
    pricing: "CENY",
    account: "ÚČET",
    logout: "ODHLÁSIT SE",
    app_name: "Digital Forensicist",
  },
  footer: {
    copyright:
      "© 2024 Digital Forensicist. Všechna práva vyhrazena. Přesné ověření identity.",
    privacy: "Zásady Ochrany Osobních Údajů",
    terms: "Podmínky Služby",
    docs: "Dokumentace",
    support: "Podpora",
  },
  common: {
    loading: "Načítání...",
    error: "Chyba",
    cancel: "Zrušit",
    back: "Zpět",
  },
  errors: {
    upload_failed: "Nahrávání selhalo. Zkuste to znovu.",
    not_enough_tokens:
      "Nemáte dostatek tokenů pro provedení tohoto vyhledávání.",
  },
  login: {
    disclaimer:
      "K používání této aplikace potřebujete účet. Nezasíláme spam ani nesdílíme váš e-mail. Doporučujeme přihlásit se přes Apple pro ochranu soukromí.",
  },
  results: {
    input_source: "VSTUPNÍ ZDROJ",
    match_thumbnail: "Náhled shody",
    extraction_id: "ID EXTRAKCE",
    scan_analysis: "Analýza skenování",
    scan_description:
      "Biometrické zpětné vyhledávání dokončeno. Nalezeno %{count} potenciálních shod ve veřejných registrech a sociálních indexech.",
    col_identity_map: "MAPA IDENTITY",
    col_verification_path: "CESTA OVĚŘENÍ",
    col_bio_match_score: "SKÓRE BIO SHODY",
    col_action: "AKCE",
    export_pdf: "Exportovat PDF",
    exporting: "Generování...",
    verified: "OVĚŘENO",
    details: "PODROBNOSTI",
    details_tooltip: "Spustit přesné porovnání obličeje",
    details_loading: "Porovnávám...",
    copied: "Zkopírováno!",
    copy_url: "Kopírovat URL",
    displaying: "Zobrazuji %{count} z %{total} detekcí",
  },
};

export default cs;
